module.exports = __webpack_public_path__ + "img/espece.9653b748.svg";